import { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { ELEVATEOS_LOGO_ALT } from '@/constants'

import API from '../../api/api'

import {
  ParkingPaymentForm,
  ParkingPaymentProcessing,
  ParkingPaymentError,
  ParkingPaymentSuccess,
} from './components/Payment'

export const PAYMENT_STAGES = {
  PAYMENT: 'PAYMENT',
  PROCESSING: 'PROCESSING',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
}

const ParkingPaymentPage = () => {
  const { t } = useTranslation(['parking'])
  const [stage, setStage] = useState(PAYMENT_STAGES.PAYMENT)
  const [serviceFee, setServiceFee] = useState(null)
  const [requestTips, setRequestTips] = useState(null)
  const [isLoading, setIsLoading] = useState(true)

  const navigate = useNavigate()
  const { ticketNumber } = useParams()

  useEffect(() => {
    const fetchFeeData = async () => {
      try {
        const resp = await API.calculateParkingFee(ticketNumber)
        setServiceFee(resp.data.serviceFee)
        setRequestTips(resp.data.requestTips)
      } catch (e) {
        console.error('Fee fetch failed', e)
      } finally {
        setIsLoading(false)
      }
    }

    fetchFeeData()
  }, [ticketNumber])

  useEffect(() => {
    const validateTicket = async () => {
      try {
        await API.getParkingTicket(ticketNumber)
      } catch {
        navigate('/parking/error/404')
      }
    }

    validateTicket()
  }, [ticketNumber])

  const renderContent = () => {
    switch (stage) {
      case PAYMENT_STAGES.PAYMENT:
        return (
          <ParkingPaymentForm
            isLoading={isLoading}
            requestTips={requestTips}
            serviceFee={serviceFee}
            ticketNumber={ticketNumber}
            setStage={setStage}
          />
        )
      case PAYMENT_STAGES.PROCESSING:
        return <ParkingPaymentProcessing />
      case PAYMENT_STAGES.ERROR:
        return <ParkingPaymentError setStage={setStage} PAYMENT_STAGES={PAYMENT_STAGES} />
      case PAYMENT_STAGES.SUCCESS:
        return <ParkingPaymentSuccess ticketNumber={ticketNumber} />
      default:
        return null
    }
  }

  return (
    <div className="parking-info">
      <img
        src="/images/logo/elevateos-logo-wide-black.svg"
        className="parking-info__header-logo"
        alt={ELEVATEOS_LOGO_ALT}
      />
      {renderContent()}
    </div>
  )
}

export default ParkingPaymentPage
